<template>
  <div class="top-tabs-bar">
    <div class="tabs-list">
      <div
        v-for="(tab, index) in tickets"
        :key="tab.ticketId"
        :class="['top-tab', { active: activeTabIndex === index }]"
      >
        <span class="tab-number" @click="$emit('switch-tab', index)">
          #{{ tab.ticketId }}
        </span>
        <button
          class="tab-close-btn"
          @click.stop="$emit('close-tab', index)"
          :title="$t('close')"
        >
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <div class="top-tab add-tab" @click="$emit('open-search')">
        <i class="mdi mdi-plus"></i>
        Відкрити тікет
      </div>
    </div>
    <div class="top-actions">
      <button
        v-if="ifPrevopen"
        @click="$emit('prev-open')"
        class="nav-btn"
        title="Попередній тікет"
      >
        <i class="mdi mdi-chevron-left"></i>
      </button>
      <button
        v-if="ifNextopen"
        @click="$emit('next-open')"
        class="nav-btn"
        title="Наступний тікет"
      >
        <i class="mdi mdi-chevron-right"></i>
      </button>
      <button class="nav-btn" @click="$emit('minimize')" title="Згорнути">
        <i class="mdi mdi-window-minimize"></i>
      </button>
      <button class="close-all-btn" @click="$emit('close-all')">
        <i class="mdi mdi-close"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TicketTabsBar",
  props: {
    tickets: {
      type: Array,
      default: () => [],
    },
    activeTabIndex: {
      type: Number,
      default: 0,
    },
    ifPrevopen: {
      type: Boolean,
      default: false,
    },
    ifNextopen: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "switch-tab",
    "close-tab",
    "open-search",
    "prev-open",
    "next-open",
    "minimize",
    "close-all",
  ],
};
</script>

<style scoped>
.top-tabs-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  padding: 8px 16px;
  flex-shrink: 0;
}

.tabs-list {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  flex: 1;
}

.top-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  transition: all 0.2s;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  white-space: nowrap;
}

.top-tab:hover {
  background: #e9ecef;
}

.top-tab.active {
  background: #1abc9c;
  color: white;
  border-color: #1abc9c;
}

.tab-number {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.tab-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 3px;
  transition: all 0.2s;
  color: inherit;
  padding: 0;
  margin-left: 4px;
}

.tab-close-btn:hover {
  background: rgba(0, 0, 0, 0.1);
}

.top-tab.active .tab-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.tab-close-btn i {
  font-size: 14px;
}

.add-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f8f9fa;
  border-color: #e9ecef;
  cursor: pointer;
}

.add-tab:hover {
  background: #1abc9c;
  color: white;
  border-color: #1abc9c;
}

.add-tab i {
  font-size: 16px;
}

.top-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 12px;
}

.nav-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: white;
  color: #495057;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  border: 1px solid #dee2e6;
}

.nav-btn:hover {
  background: #e9ecef;
  color: #212529;
}

.close-all-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: #dc3545;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  flex-shrink: 0;
}

.close-all-btn:hover {
  background: #c82333;
}

@media (max-width: 768px) {
  .top-tabs-bar {
    padding: 6px 12px;
  }

  .tabs-list {
    gap: 6px;
  }

  .top-tab {
    padding: 6px 10px;
    font-size: 12px;
  }

  .tab-close-btn {
    width: 16px;
    height: 16px;
  }

  .tab-close-btn i {
    font-size: 12px;
  }

  .add-tab {
    font-size: 12px;
    padding: 6px 10px;
  }

  .add-tab i {
    font-size: 14px;
  }

  .nav-btn,
  .close-all-btn {
    width: 28px;
    height: 28px;
  }

  .nav-btn i,
  .close-all-btn i {
    font-size: 14px;
  }
}

@media (max-width: 576px) {
  .top-tabs-bar {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
  }

  .tabs-list {
    overflow-x: auto;
    flex: none;
  }

  .top-actions {
    margin-left: 0;
    justify-content: flex-end;
    width: 100%;
  }
}
</style>
